'use strict'

require('./helpers/lazy-load')


require('./parts/cookies')
require('./parts/video')

require('./maps')

require('./layout/header')
require('./layout/custom-info-popup')

require('./elementor-blocks/hero-slider')
require('./elementor-blocks/reclams-slider')
require('./elementor-blocks/newest-products')
require('./elementor-blocks/our-manufacturers')

require('./dokan-customizations')
require('./checkout')
require('./global')
